import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {LicenseManager} from 'ag-grid-enterprise'

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

LicenseManager.setLicenseKey('uniportal_uniportal_1Devs7_June_2020__MTU5MTQ4NDQwMDAwMA==dee3174d7d9dc47f93608e2bfc4390f6')

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
